import { modelOptions, prop, Severity } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';
import { LearningStateModel } from "./learning.state";
import { TopRecommendationsModel } from "./top.recommendations.model";

@modelOptions({
  options: {allowMixed: Severity.ALLOW, customName: 'companyAttackSurfaceReductionState'},
  schemaOptions: {collection: 'companyAttackSurfaceReductionState'},
})
export class CompanyAttackSurfaceReductionState {
  @prop({required: true})
  _id: mongoose.Types.ObjectId;

  @prop({required: true})
  companyId: mongoose.Types.ObjectId;

  @prop({required: true})
  learningState: LearningStateModel;

  @prop({required: true})
  reductionPotential: number;

  @prop({required: true})
  topRecommendations: TopRecommendationsModel;
}
